import React, { useEffect, useState, useContext } from 'react';
import { ReactComponent as CloseIcon } from '@Assets/icons/close.svg';
import { HeadContext } from '../../Provider';
import { Button } from '../Button';
import Loader from '../Loader';
import ObraServices, {iObra,iFuncion, iPeriodo, iFormSearch} from '../../Services/ObraServices';
import AutorServices, {iAutor} from '../../Services/AutorServices';
import Masonry from '../Grid';
import WorkList from '../WorkList';
import './index.scss';
import { Obra } from '../../Pages/Obra';

interface iProps {
    handleClose: () => void;
}

export default (props: iProps) => {

    const [workList, setWorkList ] = useState<iObra[]>([]);
    const [page, setPage ] = useState<number>(0);
    const [autorList, setAutorList ] = useState<iAutor[]>([]);
    const [funcionesList, setFuncionesList] = useState<iFuncion[]>([]);
    const [periodosList, setPeriodosList] = useState<iPeriodo[]>([]);
    const [notFound, setNotFound] = useState<boolean>(false); 
    const [form, setForm] = useState<iFormSearch>({});
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const context = useContext(HeadContext);

    function hideSearch () {
        context.setShowSearch(false)
    }

    function handleForm(event:any) {
        let inputName = event.target.name;
        let inputValue = event.target.value;
        setForm({...form, [inputName]: inputValue})
    }

    function postSearch(reset:boolean=true){
        console.table(form)
        setIsLoading(true);
        ObraServices.postSearch(form, reset ? 0 : page +1).then( ({ data }: any) =>{
            const list:iObra[] = data.data ? data.data : []
            if(list.length > 0){
                setPage(page + 1);
                setWorkList(reset ? list : workList.concat(list));
            }else{
                setNotFound(true);
            }
        }).catch({}).finally(()=>{setIsLoading(false)});
    }

    function clickSearch () {
        setWorkList([]);
        setPage(0);
        setNotFound(false);
        postSearch();
    }

    function loadMore(){
        
        postSearch(false);
    }


    useEffect(() => {
        ObraServices.getFunciones().then( ({ data }: any) =>{
            setFuncionesList(data)
        })
        ObraServices.getPeriodos().then( ({ data }: any) =>{
            setPeriodosList(data)
        })
        AutorServices.getAll().then(({data}:any) =>{
            let listResult:any = [];
            if(data.data){
                data.data.forEach((element:any) => {
                    listResult = listResult.concat(element)
                });
                setAutorList(listResult)
            }
        })
    },[0])

    return (
        <div className="c_search">
            <div className="c_search__head">
                <img className="c_search__head_logo" src="/images/logo.png"/>
                <CloseIcon onClick={hideSearch} className="c_search__head_close"/>
            </div>
            <div className="c_search__content">
                <h2 className="c_search__title e-text-black">¿QUÉ ESTAS BUSCANDO?</h2>
                <input name="titular" onChange={handleForm} type="text" className="c_search__input_title e-p1" placeholder="BUSCAR RECURSOS POR TITULO"></input>
                <div className="c_search__form">
                    <div className="c_search__form_input_group">
                        <p className="c_search__form_input_group_label e-p3 e-p5:md e-text-bold">MEDIO</p>
                        <select name="funcion_genero" onChange={handleForm} className="c_search__form_input_group_select e-text-bold">
                            <option value="">Seleccionar</option>
                            {funcionesList.map((func)=>{
                                return (<option value={func.codigo}>{func.nombre}</option>)
                            })}
                        </select>
                    </div>
                    <div className="c_search__form_input_group">
                        <p className="c_search__form_input_group_label e-p3 e-p5:md e-text-bold">EPOCA</p>
                        <select name="periodo" onChange={handleForm} className="c_search__form_input_group_select e-text-bold">
                            <option value="">Seleccionar</option>
                            {periodosList.map((pre)=>{
                                return (<option value={pre.abreviatura}>{pre.nombre}</option>)
                            })}
                        </select>
                    </div>
                    <div className="c_search__form_input_group">
                        <p className="c_search__form_input_group_label e-p3 e-p5:md e-text-bold">AUTOR</p>
                        <select name="autor_id" onChange={handleForm} className="c_search__form_input_group_select e-text-bold">
                            <option value="">Seleccionar</option>
                            {
                                autorList.map((autor)=>{
                                    return(<option value={autor.id}>{`${autor.apellidos.length > 0 ? autor.apellidos + ",": ""} ${autor.nombres}`}</option>)
                                })
                            }
                        </select>
                    </div>
                    <div className="c_search__form_input_group">
                        <p className="c_search__form_input_group_label e-p3 e-p5:md e-text-bold">NIVEL PEDAGÓGICO</p>
                        <select onChange={handleForm} className="c_search__form_input_group_select e-text-bold">
                            <option value="">Seleccionar</option>
                        </select>
                    </div>
                </div>
                <Button action={()=>{clickSearch()}} className="c_search__button" theme="solid">BUSCAR</Button>
            </div>
            <WorkList
                className="c_search__result"
                list={workList}
                notFound={notFound}
                isLoading={isLoading}
                handleLoadMore={loadMore}
            />
        </div>   
    )
}